import gsap, { Power1 } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(DrawSVGPlugin);

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import { Ease } from '../_app/cuchillo/utils/Ease';

export default class Preloader {
    _container;
    _logo;

    static init() {
        this._container = GetBy.id('Preloader');

        if (isDebug) {
            this._container.style.display = "none";
            return;
        }

        this._logoSolid = GetBy.selector('.icon--logo', this._container);
        gsap.set(this._logoSolid, { opacity: 0 });

        this._logo = GetBy.selector('.icon--logo-stroke path', this._container);
        gsap.set(this._logo, { drawSVG: `0% 0%` });
    }

    static update() { }

    static hide(__call) {
        if (isDebug) {
            if (__call) __call();
            return;
        }

        let delay = 0;
        gsap.set(this._logo, { opacity: 1 });

        for (let i = 0; i < this._logo.length; i++) {
            const path = this._logo[i];

            let dur = i > 6 ? .5 : 1;
            let del = i > 6 ? .15 : .05;
            gsap.to(path, {
                drawSVG: `0% 100%`,
                delay: delay + i * del,
                duration: dur,
                ease: Ease.EASE_CUCHILLO_IN_OUT
            });
        }

        delay += 1.2;
        gsap.to(this._logoSolid, {
            duration: 1,
            opacity: 1,
            delay,
            ease: Power1.easeOut
        });

        delay += 1.7;
        gsap.to(this._container, {
            duration: .2,
            opacity: 0,
            delay,
            ease: Power1.easeOut,
            onComplete: () => {
                this._container.style.display = "none";
                if (__call) __call();
            }
        });
    }
}
